import { render, staticRenderFns } from "./InterviewResult.vue?vue&type=template&id=126f572d&"
import script from "./InterviewResult.vue?vue&type=script&lang=js&"
export * from "./InterviewResult.vue?vue&type=script&lang=js&"
import style0 from "./InterviewResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports